import { render } from "./startLocation.vue?vue&type=template&id=791e48de"
import script from "./startLocation.vue?vue&type=script&lang=js"
export * from "./startLocation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__